import React, { memo, useMemo } from "react";
import { Card, Col, Row } from "react-bootstrap";
import { useSelector } from "react-redux";
import { Unit } from "../../../helpers/unit";
import LoadingStyle from "../Common/LoadingStyle";

const Offload = ({ index, selectedIndex, offloadDetails, isRequesting, handleToggle, showDropdown, setShowDropdown }) => {
  const { offload_name, totalFilled = 0, total = 0, totalLoads = 0, avgYieldPerLoad = 0 } = offloadDetails || {};
  const settings = useSelector((state) => state.user.settings);
  const { payload: geoStorageReport } = useSelector((state) => state.geo.geoStorageReport);
  const totalTareCapacity = useSelector((state) => state.geo.totalTareCapacity);
  const { payload: LogisticStorageReport } = useSelector((state) => state.geo.geoLogisticStorageReport);

	const geoRegionShapeId = offloadDetails && offloadDetails.shapes && offloadDetails.shapes.length > 0 ?
		offloadDetails && offloadDetails.shapes &&
		offloadDetails.shapes[0].geo_shape_object_uuid : null;
	const geoShapeId = offloadDetails && offloadDetails.shapes && offloadDetails.shapes.length > 0 ?
		offloadDetails && offloadDetails.shapes[0].geo_shape_uuid : null;
	const report = geoStorageReport && geoStorageReport[geoShapeId];


	const unit = useMemo(() => Unit.getInstance(), []);
	
	const shapeLogisticStorageReport = useMemo(() => LogisticStorageReport[geoRegionShapeId] || null, [geoRegionShapeId, LogisticStorageReport]);

	const { logisticsTotalFilled } = useMemo(() => {
		if (!shapeLogisticStorageReport || Object.keys(shapeLogisticStorageReport).length === 0) return {};

		const logisticsTotalFilled = unit.toWeight(shapeLogisticStorageReport && shapeLogisticStorageReport.summary &&
			shapeLogisticStorageReport.summary.filledCapacity, 2);

		return {
			logisticsTotalFilled
		};
	}, [shapeLogisticStorageReport]);
	

	const tareCapacity = (tareCapacity, value) => {
		return tareCapacity && tareCapacity[value] ? tareCapacity[value] : 0
	}

	const renderFilledValue = (fullValue, tareLoadValue) => {
		return unit.formatNumber(unit.toFixedOf(fullValue, 2))
	}
	const renderFilledValueWithTare = (fullValue, tareLoadValue) => {
		const finalValue = fullValue + tareLoadValue;
		return unit.formatNumber(unit.toFixedOf(finalValue, 2))
	}
	const renderNetWeight = (fullValue, tareLoadValue) => {
		const finalValue = fullValue - tareLoadValue;
		return unit.formatNumber(unit.toFixedOf(finalValue, 2))
	}

	const tareWeightTotal = unit.toWeight(report && report.summary && report.summary.tareWeight, 2);

	let totalFilledWeight;
	const isTareIncludedLoad = unit.toWeight(tareCapacity(totalTareCapacity[geoShapeId], "totalYearTareTotal"), 2);
	if (isTareIncludedLoad) {
		totalFilledWeight = renderFilledValue(totalFilled, (unit.toWeight(tareCapacity(totalTareCapacity[geoShapeId], "totalYearTareTotal"))));
	} else {
		totalFilledWeight = renderFilledValueWithTare(totalFilled, tareWeightTotal);
	}

	const remainingWeight = Math.abs(parseInt(totalFilledWeight ? renderNetWeight(totalFilled, tareWeightTotal ? 0 :
		unit.toWeight(tareCapacity(totalTareCapacity[geoShapeId], "totalYearTareTotal"), 2)).replace(/,/g, "") : 0, 10) - logisticsTotalFilled);

	const getPercentage = () => {
		if (logisticsTotalFilled) return total && total > 0 ? Number(((remainingWeight / total) * 100).toFixed(0)) : 0;
		else return total && total > 0 ? Number(((totalFilled / total) * 100).toFixed(0)) : 0;
	}
	const percentage = getPercentage();
	const displayColor = {
		"--percentage": `${percentage > 100 ? 100 : percentage}%`,
		"--color": "#029be6",
		"--secondary-color": "#a4cbdf"
	};
	return (
		<Card.Header className={`field-item-header ${!showDropdown && "open"}`}>
			<div className="m-0 h-100 d-flex">
				<div className="btn-grp d-flex">
					<Col className="dropdown-toggle-btn" onClick={() => {
						handleToggle(index);
						setShowDropdown(!showDropdown);
					}
					}>
						{selectedIndex.includes(index) ? <i className="fa fa-chevron-down" aria-hidden="true"></i> :
							<i className="fa fa-chevron-right" aria-hidden="true"></i>}
					</Col>
				</div>

				<div className="field-details d-flex">
					<div className="field-info">
						<Row className="field-name" title={'Offload 1'}>
							<span>{offload_name}</span>
						</Row>
					</div>

					<div className="load-info" style={{ paddingLeft: "0px" }}>
						<Row className="value">{isRequesting ? <LoadingStyle /> : <> {total ? unit.formatNumber(total) : 0}</>}</Row>
						<Row className="label">{`Capacity (${settings.weightShortName})`}</Row>
					</div >

					<div className="field-completion-info">
						<Row className="m-0 w-100 h-100">
							<Col className="work-status"
								style={displayColor}>
								<Row className="h-100">
									<Col className={`m-auto`}>
										<Row className="value">{isRequesting ? <LoadingStyle /> : <>{logisticsTotalFilled ? Number(remainingWeight).toFixed(2) : totalFilled ? unit.formatNumber(totalFilled) : 0}</>}</Row>
										<Row className="label">{`Delivered (${settings.weightShortName})`}</Row>
									</Col>
									<Col className={`m-auto average`}>
										<Row className="value"> {isRequesting ? <LoadingStyle /> : totalLoads && totalLoads ? totalLoads : 0} </Row>
										<Row className="label">Loads</Row>
									</Col>
									<Col className={`m-auto average`}>
										<Row className="value">{isRequesting ? <LoadingStyle /> : (avgYieldPerLoad)}</Row>
										<Row className="label"> <span>Avg {settings.weightShortName} per load</span></Row>
									</Col>
									<Col>
										<div className="percentage">{isRequesting ? <LoadingStyle /> : <>{percentage > 100 ? 100 : percentage}%</>}</div>
									</Col>
								</Row>
							</Col>
						</Row>
					</div>
				</div>
			</div >
		</Card.Header >
	);
};

export default memo(Offload);
